import { createSlice } from '@reduxjs/toolkit'
import { jwtDecode } from 'jwt-decode'
import { authApi } from 'redux/api/auth.api'
import { buyCardApi } from 'redux/api/buy-card.api'
import { lkApi } from 'redux/api/lk.api'
import { otpApi } from 'redux/api/otp.api'
import { PURGE } from 'redux-persist'

import { RootState } from '..'
import { megaActivationApi } from '../../api/mega-card-activation.api'

type InitialState = {
  uuid: string | null
  mobile_phone: string | null
  landingBuy: boolean
  openModalAfterBuy: boolean
}

const initialState: InitialState = {
  uuid: null,
  mobile_phone: null,
  landingBuy: false,
  openModalAfterBuy: false
}

const applicationSlice = createSlice({
  name: 'applicationSlice',
  initialState,
  reducers: {
    setIsBuyLanding: (state, { payload }) => {
      state.landingBuy = payload
    },
    setOpenModalAfterBuy: (state, { payload }) => {
      state.openModalAfterBuy = payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(PURGE, () => initialState)
      // .addMatcher(buyCardApi.endpoints.apply.matchFulfilled, (state, { payload }) => {
      //   state.uuid = payload.data.uuid
      // })
      // .addMatcher(lkApi.endpoints.lkOrder.matchFulfilled, (state, { payload }) => {
      //   state.uuid = payload.data.uuid
      // })
      .addMatcher(
        authApi.endpoints.auth.matchFulfilled,
        (state, { payload }: { payload: { data: { access: string } } }) => {
          const userData: { mobile_phone: string } = jwtDecode(payload?.data.access)
          state.mobile_phone = userData.mobile_phone
        }
      )
      .addMatcher(otpApi.endpoints.otpVerify.matchFulfilled, (state, { payload }) => {
        const userData: { mobile_phone: string } = jwtDecode(payload?.data.access)
        state.mobile_phone = userData.mobile_phone
      })
  }
})

export const applicationUuidSelector = (state: RootState) => state.application.uuid
export const mobilePhoneSelector = (state: RootState) => state.application.mobile_phone
export const isBuyLandingSelector = (state: RootState) => state.application.landingBuy
export const openModalAfterBuySelector = (state: RootState) => state.application.openModalAfterBuy

export const { setIsBuyLanding, setOpenModalAfterBuy } = applicationSlice.actions
export default applicationSlice.reducer
